<div class="not-found-container">
    <nz-result
      nzStatus="404"
      nzTitle="404"
      nzSubTitle="Sorry, the page you visited does not exist."
    >
    <!--<div nz-result-extra>
        <button nz-button nzType="primary" (click)="goHome()"><span nz-icon nzType="arrow-left"></span>Back Home</button>
    </div>-->
    </nz-result>
  </div>